import {IOwnedEntity} from "./i-owned-entity";
import { IBaseOwner } from './i-base-owner';
import {IMultilanguage} from "./base-document-types";

export interface IBasePageSettings<T extends IBaseOwner | string> extends IOwnedEntity<T>, IMultilanguage {
  name: string;
  slug?: string;
}
